import countries from 'i18n-iso-countries';
import zhLocale from 'i18n-iso-countries/langs/zh.json';
import enLocale from 'i18n-iso-countries/langs/en.json';

// 注册语言包
countries.registerLocale(zhLocale);
countries.registerLocale(enLocale);

// 获取国家名称的辅助函数
const getCountryName = (code) => {
  if (!code || code === 'N/A' || code === 'UNKNOWN') {
    return '未知';
  }
  try {
    const upperCode = String(code).toUpperCase().trim();
    // 优先使用中文名称
    const nameZh = countries.getName(upperCode, 'zh', { select: 'official' });
    if (nameZh) return nameZh;
    // 如果没有中文，使用英文名称
    const nameEn = countries.getName(upperCode, 'en', { select: 'official' });
    if (nameEn) return nameEn;
    // 如果都没有，返回代码本身
    return upperCode;
  } catch (e) {
    return String(code) || '未知';
  }
};

export  {
  getCountryName,
  countries,
};